import cookieManager from "../CookieManager";
import Constants from "../Constants";
import UserAgent from "./UserAgent";
import EnvHelper from "./EnvHelper";
import { getConsentRaw } from "../consent";

class SessionHelper 
{
  /**
   * Returns the preferred device language synchronously.
   */
  static getDeviceLanguage() {
    return navigator.language || navigator.userLanguage || "unknown";
  }

  /**
   * Converts a version string into a zero-padded numeric string. (eg. "1.2.3" -> "001002003")
   */
  static getVersionRaw(version, segments = 3, width = 3) {
  if (!version || typeof version !== "string" || version === "") return "";

  const norm = version.trim().replace(/^v/i, "");

  const nums = norm
      .split(/[^0-9]+/g)
      .filter(Boolean)
      .map(s => {
        const n = parseInt(s, 10);
        return Number.isFinite(n) && n >= 0 ? n : 0;
      });

  const taken = nums.slice(0, segments);
  while (taken.length < segments) taken.push(0);

  return taken.map(n => String(n).padStart(width, "0")).join("");
}

  /**
   * Logs session data if in a test environment.
   */
  static logSessionData(sessionData) {
    if (EnvHelper.isTestEnv()) 
      console.log("[SessionHelper] Session Data:", JSON.stringify(sessionData));
  }

  /**
   * Builds and returns session data for the current user/session.
   * app_store is read directly from the URL query param — not persisted
   * in a cookie to avoid contaminating future sessions.
   */
  static get getSessionData() {
    const nav = typeof navigator !== "undefined" ? navigator : {};
    const win = typeof window !== "undefined" ? window : {};
    const scr = (win && win.screen) || {};

    const params = new URLSearchParams((win.location && win.location.search) || "");
    const appStore = params.get(Constants.APP_STORE_QUERY_PARAM) || "";

    const sessionData = {
      platform: "Webgl",
      ua_id: cookieManager.getAfUserId() || "",
      appsflyer_user_id_web: cookieManager.getAfUserId() || "",
      source_url: (win.location && win.location.href) || "",
      user_agent: nav.userAgent || "",
      skills_id: cookieManager.get(Constants.SKILLS_ID) || "",
      meta_fbp: cookieManager.get(Constants.META_FBP) || "",
      meta_fbc: cookieManager.get(Constants.META_FBC) || "",
      cookies_consent: getConsentRaw(),
      application_id: "com.tangelogames.mundigames.cash",
      brand: UserAgent.getDeviceBrand(),
      language: this.getDeviceLanguage(),
      localization_language: cookieManager.get(Constants.LANGUAGE) || "",
      os: UserAgent.getOS(),
      os_version: UserAgent.getOSVersion(),
      device_id: cookieManager.getDeviceId() || "",
      country: cookieManager.get(Constants.COUNTRY) || "",
      current_country: cookieManager.get(Constants.COUNTRY) || "",
      current_country_code: cookieManager.get(Constants.COUNTRY_CODE) || "",
      version: cookieManager.get(Constants.BUILD_VERSION) || "",
      version_raw: this.getVersionRaw(cookieManager.get(Constants.BUILD_VERSION) || ""),
      screen_width: scr.width * win.devicePixelRatio || 0,
      screen_height: scr.height * win.devicePixelRatio || 0,
      device_type: UserAgent.getDeviceType() || "",
      app_store: appStore,
    };

    this.logSessionData(sessionData);

    return sessionData;
  }
}

export default SessionHelper;
